import { BaseApi } from './base-api.service';
import URL from '../../constants/api-constants';
import { createPath, generatePath } from 'react-router-dom';
import { SearchCycle } from '../../types/search-name';
import { Cycle } from '../models/cycles';
import { ScreenFullCycleIot } from '../../components/Cycle/types';

export class ScreenService {
  private static readonly apiService = new BaseApi();

  static async getAllCyclesByScreen(data: { screenId: string; query?: SearchCycle }): Promise<Cycle[]> {
    const { screenId, query } = data;

    let path = generatePath(URL.SCREEN_CYCLES, { id: screenId });

    if (query) {
      const searchParams = new URLSearchParams(query).toString();
      path = createPath({
        pathname: path,
        search: `?${searchParams}`,
      });
    }

    const response = await this.apiService.api.get<Cycle[]>(path);

    return response.data;
  }

  static async getAllFullCyclesByScreen(data: { screenId: string; query?: SearchCycle }): Promise<ScreenFullCycleIot[]> {
    const { screenId, query } = data;

    let path = generatePath(URL.SCREEN_FULL_CYCLES, { id: screenId });

    if (query) {
      const searchParams = new URLSearchParams(query).toString();
      path = createPath({
        pathname: path,
        search: `?${searchParams}`,
      });
    }

    const response = await this.apiService.api.get<ScreenFullCycleIot[]>(path);

    return response.data;
  }
}
